import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import TextareaAutosize from 'react-textarea-autosize';
import {
  Icon,
  IconName,
  MultiSelect,
} from '@usealloy/component-library';

const FileUploadRowPropTypes = {
  file: PropTypes.shape({
    fileObj: PropTypes.shape({
      name: PropTypes.string,
      size: PropTypes.number,
    }).isRequired,
    type: PropTypes.number.isRequired,
    notes: PropTypes.string.isRequired,
  }).isRequired,
  documentTypes: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  removeFile: PropTypes.func.isRequired,
  updateFile: PropTypes.func.isRequired,
  disableNotes: PropTypes.bool,
};

const StyledCell = styled.td`
  padding: 24px 0px 0px 0px;
  vertical-align: top;
`;

const NameCell = styled(StyledCell)`
  max-width: 200px;
`;

const NoteTextArea = styled(TextareaAutosize)`
  &&& {
    font-size: 12px;
    min-height: 40px;
    min-width: 216px;
    padding: 7px 10px 1px 10px;
    box-shadow: inset 2px 2px 0 0 #d8d8d8;
    border: solid 1px #d9d9d9;
    background-color: #fafafa;
  }
`;

const RemoveFileButton = styled.button`
  opacity: 1;
  &:hover {
    color: #463361;
  }
`;

const StyledMultiSelect = styled(MultiSelect)`
  width: 144px !important;
`;

const FileUploadRow = ({
  file,
  documentTypes,
  removeFile,
  updateFile,
  disableNotes = false,
}) => {
  const handleTypeChange = typeId => {
    const updatedFile = { ...file };
    updatedFile.type = parseInt(typeId, 10);
    updateFile(file, updatedFile);
  };

  const handleNoteChange = e => {
    const updatedFile = { ...file };
    updatedFile.notes = e.target.value;
    updateFile(file, updatedFile);
  };

  const fileSplits = file.fileObj.name.split('.');
  const docName = fileSplits.slice(0, (fileSplits.length - 1)).join('.');
  const docExt = fileSplits.pop().toLowerCase();
  let displayName = `${docName}.${docExt}`;
  if (displayName.length > 24) {
    displayName = `${docName.substring(0, 18 - docExt.length)}...${docName.substring(docName.length - 3, docName.length)}.${docExt}`;
  }

  return (
    <tr>
      <NameCell>
        <p className="bold small-text line-height-normal">{displayName}</p>
        <p className="small-text line-height-normal">
          {`${file.fileObj.size / 1000} kb`}
        </p>
      </NameCell>
      <StyledCell>
        <StyledMultiSelect
          isMulti={false}
          options={documentTypes.map(type => ({
            label: `${type.type.charAt(0).toUpperCase()}${type.type.slice(1)}`.replaceAll('_', ' '),
            value: type.document_type_id,
          }))}
          defaultValue={documentTypes.filter(({ type }) => type === 'other').map(type => ({
            label: `${type.type.charAt(0).toUpperCase()}${type.type.slice(1)}`.replaceAll('_', ' '),
            value: type.document_type_id,
          }))}
          onChange={({ value }) => handleTypeChange(value)}
        />
      </StyledCell>
      <StyledCell>
        <NoteTextArea
          name="document_notes"
          value={file.notes}
          onChange={handleNoteChange}
          placeholder={disableNotes ? 'Notes are disabled for employees' : ''}
          disabled={disableNotes}
        />
      </StyledCell>
      <StyledCell>
        <RemoveFileButton
          type="button"
          className="close"
          onClick={() => removeFile(file)}
        >
          <Icon icon={IconName.CircleClose} />
        </RemoveFileButton>
      </StyledCell>
    </tr>
  );
};

FileUploadRow.propTypes = FileUploadRowPropTypes;

export default FileUploadRow;
